module.exports = __webpack_public_path__ + "static/shayne_w.ec14bbf6.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/reviews/shayne_w.png
// module id = 1718
// module chunks = 35783957827783